import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Modal } from '@/components/atoms/modal'
import { DeleteIcon } from '@/components/molecules/settings/icon/delete-icon'

type Props = {
  onClose: () => void
}

export const TransactionLinkCompleteModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal customCss={completeModalStyle}>
      <div css={css({ display: 'flex', flexDirection: 'row-reverse', padding: '20px 20px 0 0', '.icon': { width: '40px !important' } })}>
        <DeleteIcon onClick={() => onClose()} />
      </div>
      <div css={css({ flexGrow: 1, width: '100%', marginTop: -10 })}>
        <div css={css({ textAlign: 'center', fontWeight: 'bold', fontSize: 23, letterSpacing: 1.15, color: '#272727' })}>
          {t('Rooms have been attached')}
        </div>
        <div css={css({ textAlign: 'center', fontWeight: 'bold', fontSize: 14, letterSpacing: 0.7, color: '#272727', paddingTop: 12 })}>
          {t('Subjects have been moved to the reservation details')}
        </div>
      </div>
    </Modal>
  )
}

const completeModalStyle = css({
  top: 'calc((100% - 149px) / 2)',
  left: 'calc((100% - 600px) / 2)',
  height: 149,
  width: 600,
})
